module.exports = __webpack_public_path__ + "static/previous-homepage-poster-6cc6ce55760c6359b6f3d396daac682d.png";